<app-spinner-overlay></app-spinner-overlay>

<div
  style="
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 50px;
  "
>
  <div>
    <div style="font-size: 32px; color: var(--mat-color-accent); font-family: Abel">
      {{ data.comp.titolo }} {{ data.esercizio }}
    </div>
  </div>
  <div
    style="height: 1px; background-color: #707070; flex: 1; margin-right: 20px; margin-left: 20px"
  ></div>
</div>

@if (idAzienda) {
  <app-compila-assessment
    [idModulo]="data.idAutovalutazioneCompilata"
    [compilazione]="data.comp"
    (completato)="finitaCompilazione($event)"
    [salva]="salva"
  ></app-compila-assessment>
}
